import { createDate } from 'core/utils/date'

import { type SpotQuoteListItem } from '../domain/SpotQuoteListItem'
import { type SpotQuoteListLanes } from '../domain/SpotQuoteListLanes'
import { type SpotQuoteListRate } from '../domain/SpotQuoteListRate'
import { type SpotQuoteType } from '../domain/SpotQuoteType'
import {
  mapApiToCarrier,
  mapApiToQuote,
  mapApiToShipper,
  type RawCarrier,
  type RawQuote,
  type RawShipper,
} from './SpotQuoteMapper'

export type RawRate = {
  uuid: string
  status: string
  flat_rate: string | null
  per_mile_rate: number | null
  carrier_notes: string | null
  quote: RawQuote
}

export type RawLanes = {
  total: number
  pending: number
  submitted: number
  expired: number
  soonest_bid_deadline?: string
  rates: Array<RawRate>
  uuid?: string
}

export type RawSpotQuoteListItem = {
  carrier: RawCarrier
  shipper: RawShipper
  type: string
  lanes: RawLanes
  under_negotiation: boolean
}

export function mapApiToRates(rates: Array<RawRate>): Array<SpotQuoteListRate> {
  return rates.map(rate => {
    return {
      uuid: rate.uuid,
      status: rate.status,
      flatRate: rate.flat_rate,
      perMileRate: rate.per_mile_rate,
      carrierNotes: rate.carrier_notes,
      quote: mapApiToQuote(rate.quote),
    }
  })
}

export function mapApiToLanes(lanes: RawLanes): SpotQuoteListLanes {
  return {
    total: lanes.total,
    pending: lanes.pending,
    submitted: lanes.submitted,
    expired: lanes.expired,
    soonestBidDeadline: createDate(lanes.soonest_bid_deadline),
    rates: mapApiToRates(lanes.rates),
    uuid: lanes.uuid,
  }
}

export function mapApiToSpotQuoteList(
  quoteList: Array<RawSpotQuoteListItem>
): Array<SpotQuoteListItem> {
  return quoteList.map(item => {
    return {
      type: item.type as SpotQuoteType,
      carrier: mapApiToCarrier(item.carrier),
      shipper: mapApiToShipper(item.shipper),
      lanes: mapApiToLanes(item.lanes),
      isUnderNegotiation: item.under_negotiation,
    }
  })
}
